import coreTranslations from '@core-translations';
import en from './en';

const translations = {
	en: {
		...coreTranslations.en,
		...en,
	},
};

export default translations;
